module.exports = __webpack_public_path__ + "static/media/anc1kz.df79f846.pdf";